import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { MedicationRedLabelActionV3 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-medication-red-label-slot-v3',
    templateUrl: './medication-red-label-slot-v3.component.html',
    styleUrl: './medication-red-label-slot-v3.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicationRedLabelSlotComponentV3 implements SheetSlotComponentBase {

	action!: MedicationRedLabelActionV3;
	value!: string | null;

	@Input('action') set updateAction(action: MedicationRedLabelActionV3 | null) {
		this.action = action as MedicationRedLabelActionV3;
		this.value = this.action.dose?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}